import { render } from "./GraficoHistorial.vue?vue&type=template&id=1949e8d2&scoped=true"
import script from "./GraficoHistorial.vue?vue&type=script&lang=js"
export * from "./GraficoHistorial.vue?vue&type=script&lang=js"

import "./GraficoHistorial.vue?vue&type=style&index=0&id=1949e8d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1949e8d2"]])

export default __exports__